/**
 * @description 设置缓存
 * @param {String} name 缓存数据的名字
 * @param {*} value 缓存数据的值
 * @param {Number} expiredays 缓存数据的时间（天），默认关闭浏览器时失效。1/24 表示一个小时，1/24/60 表示一分钟
 */
export const set = function (name, value, expiredays) {
  let expires = '';
  if (expiredays) {
    const exdate = new Date();
    exdate.setTime(exdate.getTime() + expiredays * (24 * 3600 * 1000));
    expires = 'expires=' + exdate.toUTCString();
  }
  document.cookie = name + '=' + escape(value) + ';' + expires;
};

/**
 * @description 获取缓存的数据
 * @param {String} name 要获取的数据对应的名字
 * @return {*}
 */
export const get = function (name) {
  const arr = document.cookie.split('; ');
  for (let i = 0, len = arr.length; i < len; i++) {
    const temp = arr[i].split('=');
    if (temp[0] === name) return unescape(temp[1]);
  }
  return null;
};

/**
 * @description 删除缓存中某些数据
 * @param {String} name 要删除的数据对应的名字
 */
export const remove = function (name) {
  set(name, '', -1);
};

// 获取cookie对象，以对象表示
const getCookiesObj = function () {
  var cookies = {};
  if (document.cookie) {
    var objs = document.cookie.split('; ');
    for (var i in objs) {
      var index = objs[i].indexOf('='),
        name = objs[i].substr(0, index),
        value = objs[i].substr(index + 1, objs[i].length);
      cookies[name] = value;
    }
  }
  return cookies;
};

// 清除所有cookie
export const clear = function () {
  var cookies = getCookiesObj();
  for (var key in cookies) {
    document.cookie = key + '=; max-age=0';
  }
};

// 获取所有cookies
export const getCookies = function () {
  return getCookiesObj();
};

// 清除Cookie
export const cleanCookie = function () {
  if (document.cookie) {
    const cleanLength = document.cookie.split('; ').length - 20;
    if (cleanLength > 0) {
      for (let i = 0; i < cleanLength; i++) cleanFirstCookie();
    }
  }
};

// 清除首个Cookie
export const cleanFirstCookie = function () {
  document.cookie = document.cookie.match(/[^ =;]+(?=\=)/g)[0] + '=0;expires=' + new Date(0).toUTCString() + ';path=/';
};



// WEBPACK FOOTER //
// ./src/utils/CookieUtil.js